import axios from "./api";
class ProposalService {
  getAll(testId) {
    return axios.get(`/proposals`, {
      params: {
        testId: testId,
      },
    });
  }
  get(id) {      
    return axios.get(`/proposals/${id}`);
  }
  create(data) {
    return axios.post(`/proposals`, data);
  }
  update(id, data) {
    return axios.put(`/proposals/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/proposals/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ProposalService();
